var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTagDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 4,
    viewBox: "0 0 15 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.0335 1.2835 0.25 2.25 0.25C3.2165 0.25 4 1.0335 4 2C4 2.9665 3.2165 3.75 2.25 3.75C1.2835 3.75 0.5 2.9665 0.5 2Z",
    fill: "#386FC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C6 1.0335 6.7835 0.25 7.75 0.25C8.7165 0.25 9.5 1.0335 9.5 2C9.5 2.9665 8.7165 3.75 7.75 3.75C6.7835 3.75 6 2.9665 6 2Z",
    fill: "#386FC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2C11.5 1.0335 12.2835 0.25 13.25 0.25C14.2165 0.25 15 1.0335 15 2C15 2.9665 14.2165 3.75 13.25 3.75C12.2835 3.75 11.5 2.9665 11.5 2Z",
    fill: "#386FC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTagDots);
export default __webpack_public_path__ + "static/media/edit-tag-dots.aa29e8fbd6303e55566f76701024a642.svg";
export { ForwardRef as ReactComponent };